import { Controller } from "@hotwired/stimulus"

const ALPHABET = /[A-HJ-KM-NP-Z2-9]/
const SANITIZE = /[^A-HJ-KM-NP-Z2-9]/g

export default class extends Controller {
  static targets = ["box", "hidden", "form"]

  connect() {
    this.boxTargets.forEach((box, index) => {
      box.addEventListener("input", (e) => this.onInput(e, index))
      box.addEventListener("keydown", (e) => this.onKeydown(e, index))
      box.addEventListener("paste", (e) => this.onPaste(e, index))
    })
    this.sync()
  }

  onInput(event, index) {
    const box = event.target
    const cleaned = box.value.toUpperCase().replace(SANITIZE, "")
    box.value = cleaned.slice(-1)

    if (box.value && index < this.boxTargets.length - 1) {
      this.boxTargets[index + 1].focus()
    }

    this.sync()

    if (this.isComplete()) {
      this.element.requestSubmit()
    }
  }

  onKeydown(event, index) {
    if (event.key === "Backspace" && !event.target.value && index > 0) {
      this.boxTargets[index - 1].focus()
    }
  }

  onPaste(event, index) {
    event.preventDefault()
    const text = (event.clipboardData || window.clipboardData).getData("text").toUpperCase().replace(SANITIZE, "")
    if (!text) return

    for (let i = 0; i < text.length && index + i < this.boxTargets.length; i++) {
      this.boxTargets[index + i].value = text[i]
    }

    const nextEmpty = this.boxTargets.findIndex((b) => !b.value)
    const focusTarget = nextEmpty === -1 ? this.boxTargets[this.boxTargets.length - 1] : this.boxTargets[nextEmpty]
    focusTarget.focus()

    this.sync()

    if (this.isComplete()) {
      this.element.requestSubmit()
    }
  }

  sync() {
    this.hiddenTarget.value = this.boxTargets.map((b) => b.value).join("")
  }

  isComplete() {
    return this.boxTargets.every((b) => ALPHABET.test(b.value))
  }
}
